import { render, staticRenderFns } from "./ScoreBreakdownModal.vue?vue&type=template&id=343a6202&scoped=true&lang=pug"
import script from "./ScoreBreakdownModal.vue?vue&type=script&lang=js"
export * from "./ScoreBreakdownModal.vue?vue&type=script&lang=js"
import style0 from "./ScoreBreakdownModal.vue?vue&type=style&index=0&id=343a6202&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a6202",
  null
  
)

export default component.exports